module.exports = __webpack_public_path__ + "static/media/channel-mobile.215a952d.svg";